export const documentFormData = (documentParams) => {
  const formData = new FormData();
  const file = documentParams.attachment;
  formData.append('document[name]', file.name);
  formData.append('document[attachment]', file, file.name);
  return formData
};
